<!--&================== CONTAINER HEADER HOE ==================&-->

<div class="container-global-components">

  <!---================= CONTAINER DIVIDER BUTTONS =================--->
  <div class="divider-butons-FM">

    <div (click)="SaveHeaders()" class="btn btn-icon-text-left">
      <span class="text">Guardar</span><i class="fa-solid fa-check-double"></i>
    </div>


    <div routerLink="/Dashboard/Admin/DAdministrator" class="btn btn-icon">
      <i class="fa-solid fa-angles-left"></i>
    </div>
  </div>

  <!---================= CONTAINER DRAG AND DROP =================--->
  <div class="Container-Header">
    <h2>Modificaciones cabeceras HOE</h2>
    <div class="Subtitle">
      Seleccione o borre la casilla de verificación junto a cada columna que desee mostrar u ocultar en esta vista de
      esta página. para especificar el orden de las columnas, seleccione un número en la posición del cuadro de la
      izquierda
    </div>
    <div cdkDropList cdkDropListOrientation="horizontal" class="Container-List-Header"
      (cdkDropListDropped)="drop($event)">
      <div class="Card-List" *ngFor="let Header of CCP_Headers;let i = index" cdkDrag>
        <div class="Card-Header">
          <div class="Container-Input-Check Input-CheckBox">
            <input type="checkbox" class="ui-checkbox" [(ngModel)]="Header.Visible">
          </div>
          <div class="Container-Input-Text Input-Text-Form">
            <i class="fa-solid fa-signature"></i><input type="text" [(ngModel)]="Header.Name">
          </div>
          <div class="Container-Position">{{i+1}}</div>
        </div>
      </div>

    </div>
  </div>

</div>


<!--&================== CONTAINER PREVIEW ==================&-->

<div class="Container-Preview container-global-components">

  <!---================= SUBTITLE PREVIEW =================--->
  <div class="Subtitle">
    <h2>Previsualización</h2>
  </div>

  <!---================= CONTAINER TABLE PREVIEW =================--->
  <div class="Table-Lib Table-container-Global">
    <table>
      <thead>
        <th>Actualizar</th>
        <ng-container *ngFor="let Header of CCP_Headers">
          <th *ngIf="Header.Visible">{{Header.Name}}</th>
        </ng-container>
      </thead>
    </table>
  </div>

</div>

<!--~===================================== SECTION ALL MODALS =====================================~-->

<!---===================== MODAL FOR LOADER COMPONENT =====================--->
<div class="Container-Loader-Global" id="Loader">
  <div class="loader loader-1">
    <div class="loader-outter"></div>
    <div class="loader-inner"></div>
  </div>
</div>
